import React from 'react';

import Tag from '@atlaskit/tag/removable-tag';

export default (): React.JSX.Element => <Tag text="Tag" isRemovable={false} />;
